const mediaQueryList = window.matchMedia(`(prefers-reduced-motion: reduce)`);
export const prefersReducedMotion = () => mediaQueryList.matches === true;